// @ts-nocheck
import { useState, useEffect } from 'react';
import { penly } from '../api';

const useDebouncedPenlyUserSearch = (organisationId, defaultValue) => {
    const [email, setEmail] = useState(defaultValue ?? '');
    const [isLoading, setLoading] = useState(true);
    const [userExists, setUserExists] = useState(false);
    const [userId, setUserId] = useState(null);

    useEffect(() => {
        const searchUser = async () => {
            try {
                setLoading(true);
                // Make API call to check if user exists based on the email input
                const user = await penly.getUser(organisationId, email);
                setUserExists(true);
                setUserId(user.userId);
                setLoading(false);
            } catch (error) {
                if(error.response.status === 404){
                    setUserExists(false);
                    setUserId(null);
                }
                if(error.response.status === 400){
                    setUserExists(true);
                    setUserId(null);
                }
                setLoading(false);
            }
        };
        let timer;
        const delay = 300; // Debounce delay in milliseconds

        if (email.trim() !== '') {
            timer = setTimeout(() => {
                searchUser();
            }, delay);
        }

        return () => clearTimeout(timer);
    }, [email, organisationId]);
    const handleEmailChange = (value) => {
        setEmail(value);
    };

    const resetSearch = () => {
        setEmail(defaultValue ?? '');
        setLoading(false);
        setUserExists(false);
        setUserId(null);
    };

    return { email, isLoading, userExists, userId, handleEmailChange, resetSearch };
};

export default useDebouncedPenlyUserSearch;
